import type { Trigger } from '../../../shared/domain/flowTriggers/types.no-deps'
import type { ReportStatus } from '../../../shared/domain/reportStatus/types.no-deps'
import type { ReportStatusFlow } from '../../../shared/domain/reportStatusFlow/types.no-deps'
import type { ScheduleWithAssignees } from '../../../shared/domain/schedule/types.no-deps'
import type { DatabaseWorkflowElementTag, WorkflowChoiceTag } from '../../../shared/domain/tags/types.no-deps'
import type { WorkflowParameter } from '../../../shared/domain/workflowParameter/types.no-deps'
import type { AddInput, Workflow } from '../../../shared/domain/workflows/types.no-deps'
import type { Nullable } from '../../../shared/lib/typeHelpers.no-deps'
import type { Endpoint, Request, RequestArgs, Route } from '../types.no-deps'

export const route: Route = { method: 'PUT', pattern: '/api/procedures/:procedure/workflows/:workflow' }

type Params = { procedure: number; workflow: number }
export type Body = Partial<AddInput>
type Query = { richText?: boolean }
type Output = {
    workflow: Workflow
    // This is here to allow the server to return the current name of the
    // workflow after the update, but this should probably be replaced by a
    // slugs dict at some point
    workflowName: string
    triggers: Trigger[]
    reportStatuses: Array<Omit<ReportStatus, 'workflowId'> & { workflow: number }>
    reportStatusFlow?: Nullable<ReportStatusFlow>
    schedules: ScheduleWithAssignees[]
    tags?: string[]
    elementTags?: DatabaseWorkflowElementTag[]
    choiceTags?: WorkflowChoiceTag[]
    requiresSignature?: Workflow['requiresSignature']
    trainingRecommendations: number[]
    displaysTextContentInReports?: Workflow['displaysTextContentInReports']
    workflowParameters?: WorkflowParameter[]
}

export type EditEndpoint = Endpoint<Params, Body, Query, Output>

export const editRequest = (request: Request, args: RequestArgs<EditEndpoint>) => request<EditEndpoint>(route, args)
